<template>
    <div class="footer modulewrap">
        <div class="copyright realwrap">
            <ffcontent alias="sei_footer"></ffcontent>
        </div>
    </div>
</template>
